import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivationService } from '@app/activation/services/activation.service';
import { IBIssDialogData } from '@app/activation/services/ibiss';
import { InfoService } from '@app/core/info/info.service';
import { TranslateService } from '@ngx-translate/core';
import { AngularDeviceInformationService } from 'angular-device-information';



@Component({
  selector: 'cloud-biss-dialog',
  templateUrl: './biss-dialog.component.html',
  styleUrls: ['./biss-dialog.component.scss']
})
export class BissDialogComponent {
  hasBiss = true;
  downloadBiss = false;

  verificationMessage: string;
  operationMessage: string;
  linkDownload: string;
  operatingSystem: string;

  constructor(
    private deviceInfoService: AngularDeviceInformationService,
    private activationService: ActivationService,
    private translateService: TranslateService,
    public info: InfoService,
    public dialogRef: MatDialogRef<BissDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IBIssDialogData) { }

  ngOnInit() {
    if (this.data != null) {

      this.verificationMessage = this.data.verificationMessage;
      this.operationMessage = this.data.operationMessage;
    }
    this.getDownloadInfoLink()
  }
  getDownloadInfoLink() {
    this.operatingSystem = this.deviceInfoService.isDesktop() ? this.deviceInfoService.getDeviceInfo().os : 'WINDOWS';
    if (this.operatingSystem) {
      this.activationService.getDownloadInfo(this.mapOperatingSystem(this.operatingSystem)).subscribe((res: any) => {
        if (res.status === 200) {
          this.linkDownload = res.data.bissDownloadLink
          this.hasBiss = false;
        }
      })
    } else {
      this.info.error(this.translateService.instant('activation.biss.osNotSupported'));
    }
  }
  mapOperatingSystem(os: string) {
    if (os.toLowerCase().includes('mac')) {
      return 'MAC';
    }
    return os;
  }

  changeText() {
    this.hasBiss = false;
  }

  changeBissDownloadText() {
    this.downloadBiss = true;
  }

  onCancel(e) {
    e.preventDefault();
    this.dialogRef.close();
  }
}
